












import Vue from 'vue'
import { mdiEmail, mdiPhone } from '@mdi/js'
import { BaseDataItem } from '@/components'
import { IShippingContactData } from '@/models'

export default Vue.extend({
    name: 'ContactData',

    components: { BaseDataItem },

    props: {
        contactData: {
            type: Object as () => IShippingContactData,
            required: true,
        },
    },

    data: () => ({
        mdiEmail,
        mdiPhone,
    }),
})
